'use strict';

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _createBrowserHistory = require('history/lib/createBrowserHistory');

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

var _reactRedux = require('react-redux');

var _reduxRouter = require('redux-router');

var _browser = require('@sentry/browser');

var Sentry = _interopRequireWildcard(_browser);

var _ApiClient = require('./helpers/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _create = require('./redux/create');

var _create2 = _interopRequireDefault(_create);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _makeRouteHooksSafe = require('./helpers/makeRouteHooksSafe');

var _makeRouteHooksSafe2 = _interopRequireDefault(_makeRouteHooksSafe);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_config2.default.isProduction) {
  Sentry.init({
    dsn: 'https://9484ba49cc844cf2a3bea066b6c4606a@sentry.io/1325196'
  });
} /**
   * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
   */


var client = new _ApiClient2.default();

var dest = document.getElementById('content');
var store = (0, _create2.default)(_reduxRouter.reduxReactRouter, (0, _makeRouteHooksSafe2.default)(_routes2.default), _createBrowserHistory2.default, client, window.__data);

function initSocket() {
  var socket = (0, _socket2.default)();
  return socket;
}

global.socket = initSocket();

var component = _react2.default.createElement(_reduxRouter.ReduxRouter, { routes: (0, _routes2.default)(store) });

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store, key: 'provider' },
  component
), dest);

if (process.env.NODE_ENV !== 'production') {
  window.React = _react2.default; // enable debugger

  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
    console.error('Server-side React render was discarded. Make sure that your initial render' // eslint-disable-line no-console
    + ' does not contain any client-side code.');
  }
}

if (__DEVTOOLS__) {
  var DevTools = require('./containers/DevTools/DevTools');
  _reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    _react2.default.createElement(
      'div',
      null,
      component,
      _react2.default.createElement(DevTools, null)
    )
  ), dest);
}


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 2187
// module chunks = 0